import { render, staticRenderFns } from "./date-range-input.vue?vue&type=template&id=20135d58&scoped=true"
import script from "./date-range-input.vue?vue&type=script&lang=js"
export * from "./date-range-input.vue?vue&type=script&lang=js"
import style0 from "./date-range-input.vue?vue&type=style&index=0&id=20135d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20135d58",
  null
  
)

export default component.exports